import BaseField from './BaseField';
import $ from 'cash-dom';
import UrlHelper from '../../../../components/UrlHelper';

class TabSingleField extends BaseField {
	constructor($input) {
		super($input);

		this._isLinkTheSameAsCurrentUrl = null;

		this._initOptions();
		this._$activeOption = null;

		this._addHiddenShowAllIfNeeded();
		this._setActiveField();

		this._$options.on('click', this._clickHandler);
	}

	get isLinkTheSameAsCurrentUrl() {
		if (this._isLinkTheSameAsCurrentUrl === null) {
			const redirectLink = this._getActiveOptionLink();
			this._isLinkTheSameAsCurrentUrl = redirectLink ? UrlHelper.isLinkTheSameAsCurrentUrl(redirectLink) : false;
		}

		return this._isLinkTheSameAsCurrentUrl;
	}

	_initOptions() {
		this._$options = this._$input.find('.filter-field-option');
	}

	_addHiddenShowAllIfNeeded() {
		let hasShowAll = false;

		for (const option of this._$options) {
			if ($(option).text().trim().toLowerCase() === 'show all') {
				hasShowAll = true;
				break;
			}
		}

		if (!hasShowAll) {
			const $showAllOption = '<div class="filter-field-option hidden" data-value="">Show all</div>';
			this._$options.parent().prepend($showAllOption);
			this._initOptions();
		}
	}

	_setActiveField() {
		this._$options.removeClass('active');

		this._$options.each((i, option) => {
			const $option = $(option);
			const fieldLink = $option.data('link');

			if (fieldLink) {
				this._setActiveByLink(fieldLink, $option);
			}
		});

		if (this._$options.closest('.tabs-multiple-layout').length && !this._$options.hasClass('active')) {
			this._$options.closest('.filter-field').find('.filter-field-option[data-value=""]').addClass('active');
		}
	}

	_setActiveByLink(fieldLink, $option) {
		const currentUrl = new URL(window.location.href);
		const fieldUrl = new URL(fieldLink);

		if (currentUrl.pathname === fieldUrl.pathname) {
			this._setActive($option);
		}
	}

	_setActive($option) {
		$option.closest('.filter-field').find('.filter-field-option').removeClass('active');
		$option.addClass('active');
		this._$activeOption = $option;
	}

	_clickHandler = (e) => {
		const $option = $(e.currentTarget);

		this._setActive($option);
		const redirectLink = this._getActiveOptionLink();

		if (redirectLink) {
			this._isLinkTheSameAsCurrentUrl = UrlHelper.isLinkTheSameAsCurrentUrl(redirectLink);

			$(document).trigger(BaseField.EVENT_FILTER_FIELD_CHANGE,{
				redirectLink,
				filterName: this._getLabel(),
				currentFieldValue: this.getValue(),
			});
			return;
		} else {
			this._isLinkTheSameAsCurrentUrl = false;
		}

		$(document).trigger(BaseField.EVENT_FILTER_FIELD_CHANGE, {
			filterName: this._getLabel(),
			currentFieldValue: this.getValue(),
		});
	}

	_getActiveOptionLink() {
		return this._$activeOption ? this._$activeOption.data('link') : null;
	}

	_getLabel() {
		return this._$activeOption ? this._$activeOption.find('.text').text() : '';
	}

	getValue() {
		return this._$activeOption ? this._$activeOption.data('value') : '';
	}

	_getName() {
		const name = super._getName();

		return typeof name === 'string' ? name.replace('-tab', '') : '';
	}

	getVendors() {
		return this._$activeOption ? this._$activeOption.data('vendors') : [];
	}

	getVendorsWithOrder() {
		return this._$activeOption ? this._$activeOption.data('vendors-with-order') : [];
	}

	_getDeeplinks() {
		return this._$activeOption ? this._$activeOption.data('deeplinks') : [];
	}

	setValueAndTriggerEvent(filterValue) {
		this.setValue(filterValue);
	}

	setValue(filterValue) {
		this._$input.find(`.filter-field-option[data-value="${filterValue}"]`).trigger('click');
	}

	getShowVisiblyHiddenVendor() {
		return this._$activeOption ? !!this._$activeOption.data('show-visibly-hidden-vendor') : false;
	}

	isWithVisiblyHiddenSplit() {
		return !!this._$input.data('is-with-visibly-hidden-split');
	}
}

export default TabSingleField;
